<mat-card class="confirmar-actividad">
  <!-- Sin botón cerrar: la única salida es confirmar la actividad -->
  <app-card-header
    [title]="enEscalado ? 'Actividad no confirmada' : 'Control de actividad'"
    [icono]="enEscalado ? 'warning' : 'timer'"
    [tono]="enEscalado ? 'peligro' : 'primario'"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (!enEscalado) {
      <p class="confirmar-actividad-mensaje">
        Hace {{ data.minutosInactividad | number: '1.0-1' }} minutos que no se
        detecta actividad. Confirmá que seguís en el puesto.
      </p>
      <div class="confirmar-actividad-countdown">{{ segundosRestantes }}</div>
      <mat-progress-bar mode="determinate" [value]="progreso" />
    } @else {
      <p class="confirmar-actividad-mensaje">
        No confirmaste tu actividad a tiempo. Confirmá para continuar.
      </p>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="principal" type="button" (click)="confirmar()">
      Estoy en el puesto
    </button>
  </mat-card-actions>
</mat-card>
